export default __webpack_public_path__ + "static/media/website.b3d89f48.png";